export default [
  {isValid: false, description: '8 characters', regex: /^.{8,}$/},
  {isValid: false, description: '1 number', regex: /\d/},
  {isValid: false, description: '1 uppercase letter', regex: /[A-Z]/},
  {isValid: false, description: '1 lowercase letter', regex: /[a-z]/},
  {isValid: true, description: '0 spaces', regex: /^[^\s]*$/}
]
